<template>
  <!--   -->
  <div class="vdm-container">
    <div
      :class="[
        detailPopup.deviceType === '电子围栏'
          ? 'vdm-monitor-abs'
          : 'vdm-monitor',
      ]"
    >
      <div
        :class="[
          detailPopup.deviceType === '电子围栏'
            ? 'vdm-monitor-abs-left'
            : 'vdm-monitor-left',
        ]"
      >
        <span>报警出发时间:</span>
        <span style="color: #4be0ff">{{ lastVdm.collectionTime }}</span>
      </div>
      <div
        :class="[
          detailPopup.deviceType === '电子围栏'
            ? 'vdm-monitor-abs-middle'
            : 'vdm-monitor-middle',
        ]"
      >
        <span>污染监测值:</span>
        <span style="color: #ff7373">{{
          `${lastVdm.value ? lastVdm.value : 0}${unitType ? unitType : "mg/m³"}`
        }}</span>
      </div>
      <div
        v-if="detailPopup.deviceType === 'VDM150监测仪'"
        class="vdm-monitor-right"
      >
        <span>告警阈值:</span>
        <span style="color: #f5a623">5mg/m³</span>
      </div>
      <div
        class="vdm-monitor-right"
      >
        <span>设备名称:</span>
        <span style="color: #fff">{{ detailPopup._deviceAliasName || detailPopup.deviceAliasName }}</span>
      </div>
    </div>
    <!-- 相机 + 曲线 -->
    <div
      :style="{
        height: detailPopup.deviceType === '电子围栏' ? '500px' : '500px',
      }"
      class="vdm-top"
    >
      <div @dblclick="dbclickHandle" data-index="2" class="vdm-top-video video">
        <vdmCvr
          :videoInfo="videoInfo"
          :isScale="isScale"
          :isAll="false"
          width="500px"
          height="200px"
          left="-104%"
          backgroundColor="#000"
        />
      </div>
      <div class="vdm-top-chart">
        <div class="chartTop">
          <span>污染监测历史曲线</span>
          <el-form ref="form" :inline="true">
            <el-form-item label="起止时间">
              <DatePicker
                :init-width="'420px'"
                :start-time-str="dateRange[0]"
                :end-time-str="dateRange[1]"
                @dateChange="changeTime"
                topPx="50px"
                dateType="timerange"
                :current-date-list="dateRange"
              >
              </DatePicker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search">查询</el-button>
              <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div ref="Echart" class="chartBottom"></div>
      </div>
    </div>
    <!-- 全景 -->
    <div @dblclick="dbclickHandle" data-index="1" class="vdm-bottom">
      <div class="vdm-bottom-title">全景相机</div>
      <div class="vdm-carema carema">
        <vdmCvr
          :videoInfo="videoSenceInfo_1"
          :isScale="isScale"
          :isAll="true"
          width="1545px"
          height="380px"
          left="0"
          backgroundColor="#000"
        />
      </div>
    </div>
    <div @dblclick="dbclickHandle" data-index="1" class="vdm-bottom">
      <div class="vdm-bottom-title">全景相机</div>
      <div class="vdm-carema carema">
        <vdmCvr
          :videoInfo="videoSenceInfo_2"
          :isScale="isScale"
          :isAll="true"
          width="1545px"
          height="380px"
          left="0"
          backgroundColor="#000"
        />
      </div>
    </div>

    <div v-show="isScale" class="vdm-scale">
      <div class="el-icon-circle-close closeBtn" @click="returnFunc()">
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import getVdmOpt from "./chart/vdmChart.js";
import vdmCvr from "@/modules/videoComponents/component/vdmCvr.vue";
import { unwarp, getOpt } from "@/utils/tools.js";
import { DatePicker } from "@/modules/commonDatePicker";
export default {
  name: "VdmDetail",
  components: { vdmCvr,DatePicker },
  props: {
    detailPopup: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    detailPopup: {
      handler(n) {
        this.reset();
      },
      deep: true,
    },
  },
  data() {
    return {
      loading: false,
      isScale: false,
      nvrIp: "",
      channelId: "",
      unitType: "",
      lastTime: "",
      recodeDate: "",
      chart: null,
      dateRange: [
        moment(new Date() - 24 * 3600 * 1000).format("YYYY-MM-DD HH:mm:ss"),
        moment().format("YYYY-MM-DD HH:mm:ss"),
      ],
      vdmImgList: [],
      lastVdm: {},
      videoInfo: {},
      videoSenceInfo_1: {},
      videoSenceInfo_2: {},
    };
  },
  methods: {
    changeTime(time) {
      this.dateRange = time;
    },
    async search() {
      this.loading = true;
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      console.log("点击了vdm", this.detailPopup);
      let url = CONFIG.requestName + this.$apiOpt.findDeviceDetail;
      // let url =
      //   "http://screen.bmetech.com/screen" + this.$apiOpt.findDeviceDetail;
      try {
        let res = await this.$apiUtils.get(url, {
          customerId: this.$store.state.customerId,
          // customerId: 38,
          deviceNo: this.detailPopup._deviceNo || this.detailPopup.deviceNo,
          // deviceNo: "BMEVDM0A210423008",
          type: 1,
          signalNo: this.detailPopup._signalNo || this.detailPopup.signalNo,
          // signalNo: "BMEVDM0A210423008_263",
          startTime: this.dateRange[0],
          endTime: this.dateRange[1],
        });
        this.loading = false;
        if (res.shedVdmVideo) {
          const { diskIpAddress, videoChannel } = res.shedVdmVideo;
          this.nvrIp = diskIpAddress;
          this.channelId = videoChannel;
        }
        const { vdmImgList, signalDetailList, unit } = res.vdms[0];
        if (vdmImgList && vdmImgList.length) {
          let list = vdmImgList.sort((a, b) => {
            return (
              new Date(a.collectionTime).getTime() -
              new Date(b.collectionTime).getTime()
            );
          });
          this.vdmImgList = list;
          this.lastTime =
            this.vdmImgList[this.vdmImgList.length - 1]["collectionTime"];
          this.lastVdm = this.vdmImgList[this.vdmImgList.length - 1];
        } else {
          this.lastTime = "";
          this.lastVdm = {};
          this.vdmImgList = [];
        }
        if (unit) this.unitType = unit;
        if (signalDetailList && signalDetailList.length) {
          this.disposeVdmList(signalDetailList);
        }
        if(!this.lastTime) {
          this.lastTime = moment(this.dateRange[0]).format("YYYY-MM-DD") + " 00:00:00";
        }
        this.videoInfo = {
          szIp: this.nvrIp,
          iChannelId: this.channelId,
          recodeDate: this.lastTime,
          type: 'vdm'
        };
        this.videoSenceInfo_1 = {
          szIp: "50.10.125.94",
          iChannelId: 22,
          recodeDate: this.lastTime,
          type: '全景1'
        };
        this.videoSenceInfo_2 = {
          szIp: "50.10.125.94",
          iChannelId: 23,
          recodeDate: this.lastTime,
          type: '全景2'
        };
        console.log(this.videoInfo, "videoInfo");
      } catch (err) {
        console.error(err);
        this.loading = false;
      }
    },
    reset() {
      this.dateRange = [
        moment(new Date().getTime() - 24 * 3600 * 1000).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss"),
      ];
      this.search();
    },
    disposeVdmList(list) {
      let pmData = {
        xData: [],
        y1Data: [],
        y2Data: [],
      };
      list.sort((a, b) => {
        return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
      });
      list.forEach((item) => {
        pmData.xData.push(item.dateTime);
        pmData.y1Data.push(item.value);
      });
      this.vdmImgList.forEach((m) => {
        let collectionTime = m.collectionTime;
        let pmDataList = $.extend([], pmData.xData, true);
        if (pmDataList.length > 2) {
          for (var i = 0; i < pmDataList.length - 1; i++) {
            if (
              new Date(collectionTime).getTime() >
              new Date(pmDataList[i]).getTime()
            ) {
              if (
                new Date(collectionTime).getTime() <
                new Date(pmDataList[i + 1]).getTime()
              ) {
                pmData.xData.splice(i + 1, 0, collectionTime);
                pmData.y1Data.splice(i + 1, 0, m.value);
              }
            }
          }
        }
      });
      this.vdmImgList.forEach((v) => {
        let arr = [];
        arr = [
          v.collectionTime,
          v.value || 0,
          {
            isWarning: v.isAlarm ? "1" : "0",
            imgUrl: v.imgUrl,
            vdmTdc: v.value,
            happenTime: v.collectionTime,
            idx: v.id,
          },
        ];
        pmData.y2Data.push(arr);
      });
      this.$nextTick(() => {
        if (this.chart) {
          this.chart.dispose();
          this.chart = null;
        }
        this.chart = echarts.init(this.$refs.Echart);
        let options = getVdmOpt(pmData, this);
        console.log(pmData.y2Data, options, "option");
        this.chart.resize();
        unwarp(this.chart).setOption(options, false);
        this.chart.on("click", (param) => {
          const { data } = param;
          let tmp = data[0];
          this.recodeDate = tmp;
          let index = this.vdmImgList.findIndex(
            (item) => item.collectionTime === tmp
          );
          if (index !== -1) this.lastVdm = this.vdmImgList[index];
          this.videoInfo = {
            szIp: this.nvrIp,
            iChannelId: this.channelId,
            recodeDate: this.recodeDate,
          };
          // this.videoSenceInfo_1 = {
          //   szIp: "50.10.125.94",
          //   iChannelId: 16,
          //   recodeDate: this.lastTime,
          // };
          // this.videoSenceInfo_2 = {
          //   szIp: "50.10.125.94",
          //   iChannelId: 17,
          //   recodeDate: this.lastTime,
          // };
        });
      });
    },
    dbclickHandle(event) {
      let index = event.currentTarget.getAttribute("data-index");
      if (parseInt(index) === 1) {
        $(".carema").removeClass("vdm-carema").addClass("scale");
        $(".vdm-top").addClass("relative");
      } else {
        $(".video").removeClass("vdm-top-video").addClass("scale");
      }
      this.isScale = true;
    },
    returnFunc() {
      this.isScale = false;
      $(".carema").removeClass("scale").addClass("vdm-carema");
      $(".video").removeClass("scale").addClass("vdm-top-video");
      $(".vdm-top").removeClass("relative");
    },
  },
  mounted() {
    this.reset();
  },
  unmounted() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.vdm {
  &-monitor {
    height: 100px;
    display: flex;
    justify-content: flex-start;
    line-height: 100px;
    text-align: center;
    font-size: 20px;
    &-left,
    &-middle,
    &-right {
      flex: 1;
      > span:nth-child(1) {
        margin-right: 30px;
      }
    }
  }
  &-monitor-abs {
    position: absolute;
    top: 50px;
    left: 100px;
    &-middle {
      > span:nth-child(1) {
        margin-right: 0;
      }
    }
    &-left,
    &-middle {
      display: flex;
      width: 500px;
      font-size: 20px;
      margin-bottom: 10px;
      > span:nth-child(1) {
        width: 30%;
      }
      > span:nth-child(2) {
        width: 70%;
      }
    }
  }
  &-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 20px 170px 20px 0px;
    position: relative;
  }
  &-top {
    // height: 450px;
    margin-bottom: 30px;
    &-video {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 240px;
      cursor: pointer;
      margin-bottom: 30px;
      background-color: #15244d;
    }
    &-chart {
      height: 230px;
      background: rgba(0, 0, 0);
    }
  }
  &-carema {
    height: 430px;
    cursor: pointer;
  }
  &-bottom {
    height: 430px;
    &-title {
      position: absolute;
      width: 100%;
      height: 48px;
      z-index: 9999;
      padding: 0 20px;
      font-size: 34px;
      line-height: 48px;
    }
  }
  &-scale {
    width: 1543px;
    height: 1000px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999999;
  }
  &-trigger {
    height: 200px !important;
  }
}
.chartTop {
  height: 70px;
  display: flex;
  line-height: 115px;
  margin-bottom: 10px;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  > span {
    font-size: 30px;
  }
}
.chartBottom {
  height: calc(100% - 70px);
  background-color: #15244d;
}
</style>
<style lang="scss" scoped>
.scale {
  position: absolute;
  top: 50%;
  left: 45%;
  width: 1545px;
  transform: translate(-50%, -50%);
  z-index: 9999999;
}
.relative {
  overflow: hidden;
}
.closeBtn {
  position: absolute;
  top: 10px;
  right: 10px;
}
.el-icon-circle-close:before {
  font-size: 50px;
  cursor: pointer;
}
</style>
